/**
 * Classe esempio
 */
class Module {

    constructor(options) {
        this.run();
    }

    run() {
        this.debug('ADAbe avviato');
    }

    debug(message) {
    }
}

// export
export default (options) => {
    return new Module(options);
}